export default {
  "name": "NCCol",
  "column": 1,
  "canAppend": true,
  "type": 1,
  "path": "LowCodeComponents.NCCol",
  "label": "列容器",
  "schema": {
    "type": "object",
    "properties": {
      "moduleId": {
        "title": "区域编码",
        "description": "组件标识",
        "type": "string"
      },
      "xs": {
        "title": "xs",
        "description": "显示列数",
        "enumNames": [
          "",
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9,
          10,
          11,
          12
        ],
        "type": "enum",
        "enum": [
          "",
          "1",
          "2",
          "3",
          "4",
          "5",
          "6",
          "7",
          "8",
          "9",
          "10",
          "11",
          "12"
        ],
        "default": "6"
      },
      "sm": {
        "title": "sm",
        "description": "显示列数",
        "type": "enum",
        "enum": [
          "",
          "1",
          "2",
          "3",
          "4",
          "5",
          "6",
          "7",
          "8",
          "9",
          "10",
          "11",
          "12"
        ],
        "default": "6"
      },
      "md": {
        "title": "md",
        "description": "显示列数",
        "type": "enum",
        "enum": [
          "",
          "1",
          "2",
          "3",
          "4",
          "5",
          "6",
          "7",
          "8",
          "9",
          "10",
          "11",
          "12"
        ],
        "default": "6"
      },
      "lg": {
        "title": "lg",
        "description": "显示列数",
        "type": "enum",
        "enum": [
          "",
          "1",
          "2",
          "3",
          "4",
          "5",
          "6",
          "7",
          "8",
          "9",
          "10",
          "11",
          "12"
        ],
        "default": "6"
      },
      "xsPull": {
        "title": "xsPull",
        "description": "移动屏幕设备到右边距列数",
        "type": "enum",
        "enum": [
          "",
          "1",
          "2",
          "3",
          "4",
          "5",
          "6",
          "7",
          "8",
          "9",
          "10",
          "11",
          "12"
        ]
      },
      "smPull": {
        "title": "smPull",
        "description": "小屏幕设备到右边距列数",
        "type": "enum",
        "enum": [
          "",
          "1",
          "2",
          "3",
          "4",
          "5",
          "6",
          "7",
          "8",
          "9",
          "10",
          "11",
          "12"
        ]
      },
      "mdPull": {
        "title": "mdPull",
        "description": "中等屏幕设备到右边距列数",
        "type": "enum",
        "enum": [
          "",
          "1",
          "2",
          "3",
          "4",
          "5",
          "6",
          "7",
          "8",
          "9",
          "10",
          "11",
          "12"
        ]
      },
      "lgPull": {
        "title": "lgPull",
        "description": "大屏幕设备到右边距列数",
        "type": "enum",
        "enum": [
          "",
          "1",
          "2",
          "3",
          "4",
          "5",
          "6",
          "7",
          "8",
          "9",
          "10",
          "11",
          "12"
        ]
      },
      "xsPush": {
        "title": "xsPush",
        "description": "移动屏幕设备到左边距列数",
        "type": "enum",
        "enum": [
          "",
          "1",
          "2",
          "3",
          "4",
          "5",
          "6",
          "7",
          "8",
          "9",
          "10",
          "11",
          "12"
        ]
      },
      "smPush": {
        "title": "smPush",
        "description": "小屏幕设备到左边距列数",
        "type": "enum",
        "enum": [
          "",
          "1",
          "2",
          "3",
          "4",
          "5",
          "6",
          "7",
          "8",
          "9",
          "10",
          "11",
          "12"
        ]
      },
      "mdPush": {
        "title": "mdPush",
        "description": "中等屏幕设备到左边距列数",
        "type": "enum",
        "enum": [
          "",
          "1",
          "2",
          "3",
          "4",
          "5",
          "6",
          "7",
          "8",
          "9",
          "10",
          "11",
          "12"
        ]
      },
      "lgPush": {
        "title": "lgPush",
        "description": "大屏幕设备到左边距列数",
        "type": "enum",
        "enum": [
          "",
          "1",
          "2",
          "3",
          "4",
          "5",
          "6",
          "7",
          "8",
          "9",
          "10",
          "11",
          "12"
        ]
      },
      "xsOffset": {
        "title": "xsOffset",
        "description": "移动屏幕设备偏移列数",
        "type": "enum",
        "enum": [
          "",
          "1",
          "2",
          "3",
          "4",
          "5",
          "6",
          "7",
          "8",
          "9",
          "10",
          "11",
          "12"
        ]
      },
      "smOffset": {
        "title": "smOffset",
        "description": "小屏幕设备偏移列数",
        "type": "enum",
        "enum": [
          "",
          "1",
          "2",
          "3",
          "4",
          "5",
          "6",
          "7",
          "8",
          "9",
          "10",
          "11",
          "12"
        ]
      },
      "mdOffset": {
        "title": "mdOffset",
        "description": "中等屏幕设备偏移列数",
        "type": "enum",
        "enum": [
          "",
          "1",
          "2",
          "3",
          "4",
          "5",
          "6",
          "7",
          "8",
          "9",
          "10",
          "11",
          "12"
        ]
      },
      "lgOffset": {
        "title": "lgOffset",
        "description": "大屏幕设备偏移列数",
        "type": "enum",
        "enum": [
          "",
          "1",
          "2",
          "3",
          "4",
          "5",
          "6",
          "7",
          "8",
          "9",
          "10",
          "11",
          "12"
        ]
      }
    },
    "required": [
      "moduleId"
    ]
  },
  "uiSchema": {},
  "slots": []
}